import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allMonedasAction } from '../MonedasAction';

const SelectFieldMonedasComponent = ({
  onChange,
  value = '',
  data,
  id = 'select-monedas',
  isAll = true,
  isAllText = false,
  isEmpty = false,
  selects = [],
  required = false,
  error = false,
}) => {
  const dispatch = Redux.useDispatch();

  const monedasStore = Redux.useSelector((state) => state.monedas);

  const [monedas, setMonedas] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      monedasStore.all.forEach((moneda) => {
        const existSeletc = selects.some((item) => item.id === moneda.id);
        if (!existSeletc) items.push(moneda);
      });
      setMonedas(items);
    } else {
      if (data) {
        setMonedas(data);
      } else {
        setMonedas(monedasStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && monedasStore.all && monedasStore.all.length === 0) {
        await allMonedasAction(dispatch, null);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${id}`}>{CONST.moneda.label}</InputLabel>
      <Select
        id={id}
        value={value?.toString()}
        labelId={`label_${id}`}
        label={CONST.moneda.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty && (
          <MenuItem key={`item_${id}_000`} value={null}>
            {isAll ? 'TODOS' : 'NINGUNO'}
          </MenuItem>
        )}

        {isAllText && !isEmpty && (
          <MenuItem key={`item_${id}_all`} value={'all'}>
            TODOS
          </MenuItem>
        )}
        {monedas.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.abrev}: {el.nombre} ({el.simbolo})
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectFieldMonedasComponent;
